import { fork, take, call, put, takeLatest } from "redux-saga/effects";

import {
  onUploadRes,
  searchUserResponse,
  userDetailResponse,
  userDetailBrokerResponse,
  userDetailIframeUserResponse,
  userUpdateResponse,
  onUploadResBroker,
  getProfileCompletePercentageResponse,
  getLicensedAsResponse,
  getBannerCardSummaryResponse,
  getRoleRequestedResponse,
  acceptRoleReqResponse,
  getUserOfRoleAcceptedResponse,
  UserRoleCancelResponse,
  UserRoleRequestStatusResponse,
  fetchTimezoneArrayResponse,
  fetchTimezoneAbbrResponse,
  onPostUploadRes,
  getLeaderBoardRes,
  getUserPointsRes,
  onEditUploadRes,
  getCheckListApprovalRes,
  checkListApprovalStatusRes,
  changePasswordRes,
  getProvinceMasterDataResponse,
  userDetailOtherResponse,
  getBrandThemeResponse,
  getBrandDetailsResponse,
  checkEmailExistsResponse,
  updateCoverPhotoResponse,
  getCoachingNotesListReqResponse,
  addCoachingNotesListReqResponse,
  getMyTeamListReqResponse,
  userDetailBrokerResponseForOther,
  impersonateUserResponse,
  getCityListResponse,
  getSlotsResponse,
  getLanguagesResponse,
  saveLeaderboardResponse,
  getDeleteTeamResponse,
} from "./actions";
import authTypes from "./types";
import {
  onCoverUpload,
  onUpload,
  postUpload,
  searchUser,
  userDetail,
  userUpdate,
} from "../../api/userDetailApi";
import { apiDirect, postAPIWithoutModule } from "../../api/generic";

export function* getUserDetail() {
  while (true) {
    const { payload } = yield take(authTypes.USER_DETAIL);
    const response = yield call(userDetail, payload);
    yield put(userDetailResponse(response));
  }
}

export function* getUserDetailBroker() {
  while (true) {
    const { payload } = yield take(authTypes.USER_DETAIL_BROKER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(userDetailBrokerResponse(response));
  }
}

export function* getUserDetailBrokerForOther() {
  while (true) {
    const { payload } = yield take(authTypes.USER_DETAIL_BROKER_FOR_OTHER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(userDetailBrokerResponseForOther(response));
  }
}

export function* getUserDetailIframeUserBroker() {
  while (true) {
    const { payload } = yield take(authTypes.USER_DETAIL_IFRAME_USER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(userDetailIframeUserResponse(response));
  }
}

export function* userUpdateReq() {
  while (true) {
    const { payload } = yield take(authTypes.USER_UPDATE);
    const response = yield call(userUpdate, payload);
    yield put(userUpdateResponse(response));
  }
}

export function* doSearchUser() {
  while (true) {
    const { payload } = yield take(authTypes.SEARCH_USER_REQ);
    const response = yield call(searchUser, payload);
    yield put(searchUserResponse(response));
  }
}

export function* doOnUploadProfile() {
  while (true) {
    const { payload } = yield take(authTypes.ON_UPLOAD_REQ);
    const response = yield call(onUpload, payload);
    yield put(onUploadRes(response));
  }
}

export function* doOnUploadProfileBroker() {
  while (true) {
    const { payload } = yield take(authTypes.ON_UPLOAD_REQ_BROKER);
    const response = yield call(onUpload, payload);
    yield put(onUploadResBroker(response));
  }
}

export function* getProfilePercentageData() {
  while (true) {
    const { payload } = yield take(authTypes.GET_PROFILE_PERCENTAGE);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getProfileCompletePercentageResponse(response));
  }
}

export function* doGetLicensedAsList() {
  while (true) {
    const { payload } = yield take(authTypes.GET_LICENSED_AS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getLicensedAsResponse(response));
  }
}

export function* doGetBrandTheme() {
  while (true) {
    const { payload } = yield take(authTypes.GET_BRAND_THEME);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getBrandThemeResponse(response));
  }
}

export function* doGetBannerCardSummary() {
  while (true) {
    const { payload } = yield take(authTypes.BANNER_CARD_SUMMARY);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getBannerCardSummaryResponse(response));
  }
}

export function* doGetRoleRequestedList() {
  while (true) {
    const { payload } = yield take(authTypes.GET_ROLE_REQUESTED);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getRoleRequestedResponse(response));
  }
}

export function* doAcceptRoleRequest() {
  while (true) {
    const { payload } = yield take(authTypes.ACCEPT_ROLE_REQUESTED);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(acceptRoleReqResponse(response));
  }
}

export function* doGetUserOfRoleAccepted() {
  while (true) {
    const { payload } = yield take(authTypes.GET_USER_OF_ROLE_ACCEPTED);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getUserOfRoleAcceptedResponse(response));
  }
}
export function* doUserRoleAcceptanceCancel() {
  while (true) {
    const { payload } = yield take(authTypes.USER_ROLE_CANCEL);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(UserRoleCancelResponse(response));
  }
}
export function* doUserRoleAcceptanceStatus() {
  while (true) {
    const { payload } = yield take(authTypes.USER_ROLE_REQUEST_STATUS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(UserRoleRequestStatusResponse(response));
  }
}

export function* doTimeZoneFetch() {
  while (true) {
    const { payload } = yield take(authTypes.TIMEZONE_ARRAY_FETCH);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(fetchTimezoneArrayResponse(response));
  }
}

export function* doTimeZoneFetchAbbr() {
  while (true) {
    const { payload } = yield take(authTypes.TIMEZONE_ABBR_FETCH);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(fetchTimezoneAbbrResponse(response));
  }
}

export function* doPostUpload() {
  while (true) {
    const { payload } = yield take(authTypes.POST_UPLOAD);
    const response = yield call(postUpload, payload);
    yield put(onPostUploadRes(response));
  }
}

export function* doEditPost() {
  while (true) {
    const { payload } = yield take(authTypes.EDIT_UPLOAD);
    const response = yield call(postUpload, payload);
    yield put(onEditUploadRes(response));
  }
}

export function* doGetLeaderBoard() {
  while (true) {
    const { payload } = yield take(authTypes.LEADERBOARD);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getLeaderBoardRes(response));
  }
}

export function* doGetUserPoints() {
  while (true) {
    const { payload } = yield take(authTypes.USER_POINTS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getUserPointsRes(response));
  }
}

export function* getCheckListApprovalList() {
  while (true) {
    const { payload } = yield take(authTypes.CHECKLITST_APPROVAL_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCheckListApprovalRes(response));
  }
}

export function* checkListApprovalStatus() {
  while (true) {
    const { payload } = yield take(authTypes.CHECKLITST_APPROVAL_STATUS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(checkListApprovalStatusRes(response));
  }
}

export function* doChangePassword() {
  while (true) {
    const { payload } = yield take(authTypes.CHANGE_PASSWORD_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(changePasswordRes(response));
  }
}

export function* doGetProvinceMaster() {
  while (true) {
    const { payload } = yield take(authTypes.PROVINCE_MASTER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getProvinceMasterDataResponse(response));
  }
}

export function* doGetUserDetailOther() {
  while (true) {
    const { payload } = yield take(authTypes.USER_DETAIL_OTHER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(userDetailOtherResponse(response));
  }
}

export function* doGetUserBranding() {
  while (true) {
    const { payload } = yield take(authTypes.GET_USER_BRANDING);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getBrandDetailsResponse(response));
  }
}

export function* doCheckEmailExists(action) {
  const response = yield call(apiDirect, action.payload);
  yield put(checkEmailExistsResponse(response));
}

export function* doUpdateCoverPhoto() {
  while (true) {
    const { payload } = yield take(authTypes.COVER_UPDATE);
    const response = yield call(onCoverUpload, payload);
    yield put(updateCoverPhotoResponse(response));
  }
}

export function* doGetCoachingNotes() {
  while (true) {
    const { payload } = yield take(authTypes.GET_COACHING_NOTES);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCoachingNotesListReqResponse(response));
  }
}

export function* doAddCoachingNotes() {
  while (true) {
    const { payload } = yield take(authTypes.ADD_COACHING_NOTES);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(addCoachingNotesListReqResponse(response));
  }
}

export function* doGetMyTeamList() {
  while (true) {
    const { payload } = yield take(authTypes.GET_MY_TEMS_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getMyTeamListReqResponse(response));
  }
}

export function* userImpresonate() {
  while (true) {
    const { payload } = yield take(authTypes.IMPERSONATE_USER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(impersonateUserResponse(response));
  }
}

export function* doGetCitiesList() {
  while (true) {
    const { payload } = yield take(authTypes.GET_CITY);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCityListResponse(response));
  }
}

export function* doGetSlotsList() {
  while (true) {
    const { payload } = yield take(authTypes.GET_SLOTS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSlotsResponse(response));
  }
}

export function* doSaveLeaderboard() {
  while (true) {
    const { payload } = yield take(authTypes.SAVE_LEADERBOARD);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(saveLeaderboardResponse(response));
  }
}

export function* doGetLanguagesList() {
  while (true) {
    const { payload } = yield take(authTypes.GET_LANGUAGES);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getLanguagesResponse(response));
  }
}

export function* doDeleteTeam() {
  while (true) {
    const { payload } = yield take(authTypes.DELETE_TEAM);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getDeleteTeamResponse(response));
  }
}

function* user() {
  yield fork(getUserDetail);
  yield fork(getUserDetailBroker);
  yield fork(getUserDetailBrokerForOther);
  yield fork(getUserDetailIframeUserBroker);
  yield fork(userUpdateReq);
  yield fork(doSearchUser);
  yield fork(doOnUploadProfile);
  yield fork(doOnUploadProfileBroker);
  yield fork(getProfilePercentageData);
  yield fork(doGetLicensedAsList);
  yield fork(doGetBannerCardSummary);
  yield fork(doGetRoleRequestedList);
  yield fork(doAcceptRoleRequest);
  yield fork(doGetUserOfRoleAccepted);
  yield fork(doUserRoleAcceptanceCancel);
  yield fork(doUserRoleAcceptanceStatus);
  yield fork(doTimeZoneFetch);
  yield fork(doTimeZoneFetchAbbr);
  yield fork(doPostUpload);
  yield fork(doGetLeaderBoard);
  yield fork(doGetUserPoints);
  yield fork(doEditPost);
  yield fork(getCheckListApprovalList);
  yield fork(checkListApprovalStatus);
  yield fork(doChangePassword);
  yield fork(doGetProvinceMaster);
  yield fork(doGetUserDetailOther);
  yield fork(doGetBrandTheme);
  yield fork(doGetUserBranding);
  yield takeLatest(authTypes.CHECK_EMAIL_EXISTS, doCheckEmailExists);
  yield fork(doUpdateCoverPhoto);
  yield fork(doGetCoachingNotes);
  yield fork(doAddCoachingNotes);
  yield fork(doGetMyTeamList);
  yield fork(userImpresonate);
  yield fork(doGetCitiesList);
  yield fork(doGetSlotsList);
  yield fork(doSaveLeaderboard);
  yield fork(doGetLanguagesList);
  yield fork(doDeleteTeam);
}
export default user;
